import { createContext } from 'react'

export const AlertContext = createContext()
export const RouteFormContext = createContext()
export const RouteAssessmentFormContext = createContext()
